// hooks/useSupportedLocations.js
import { useEffect, useState } from "react";

// hooks/useSupportedLocations.js
import { publicRqClient } from "../../shared/api/instance";

export default function useSupportedLocations() {
  const { data, isLoading } = publicRqClient.useQuery(
    "get",
    "/locations/v1/locations/supported",
    {},
    {
      staleTime: 1000 * 60 * 60, // 1 hour cache
    }
  );

  return {
    locations: data?.data || [],
    loading: isLoading,
  };
}
